/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} North_Sour_Jurgen_FeastInputs */

const fr_north_sour_jurgen_feast = /** @type {(inputs: North_Sour_Jurgen_FeastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CrossFit Les Sables-d'Olonne`)
};

/**

* @param {North_Sour_Jurgen_FeastInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const north_sour_jurgen_feast = /** @type {((inputs?: North_Sour_Jurgen_FeastInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<North_Sour_Jurgen_FeastInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_north_sour_jurgen_feast(inputs)
});